import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { InitialsAvatar } from '../ui/InitialsAvatar';
import { StatusPill } from '../ui/StatusPill';

interface MemberRowProps {
  name: string;
  secondary?: string;
  role?: 'admin' | 'member';
  actions?: React.ReactNode;
}

// Avatar + name + optional role pill + trailing actions; stacked rows share a top border.
export const MemberRow = ({ name, secondary, role, actions }: MemberRowProps) => {
  const { t } = useTranslation('groups');
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, px: 2, py: 1.25, flexWrap: 'wrap', '& + &': { borderTop: '1px solid var(--border)' } }}>
      <InitialsAvatar name={name} size={32} />
      <Box sx={{ flex: 1, minWidth: 140, display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ fontSize: 14, fontWeight: 500, overflowWrap: 'anywhere' }}>{name}</Box>
        {secondary && <Box sx={{ fontSize: 12, color: 'var(--muted)', overflowWrap: 'anywhere' }}>{secondary}</Box>}
      </Box>
      {role && <StatusPill label={t(`roles.${role}`)} tone={role === 'admin' ? 'accent' : 'muted'} />}
      {actions && <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>{actions}</Box>}
    </Box>
  );
};
